export default {
    getBreadcrumbList(type) {
        let result = []
        result.push({
            id: "Breadcrumb1",
            title: "首页",
            route: "/",
        })
        if (type.indexOf("news") !== -1) {
            result.push({
                id: "Breadcrumb2",
                title: "新闻中心",
                route: "/article?breadcrumb_type=" + type,

            })
            if (type === "news") {
                return result
            }
            result.push({
                id: "Breadcrumb3",
                title: "",
                route: "/article_next?breadcrumb_type=" + type,

            })
            if (type.indexOf("1") !== -1) {
                result[2].title = "重要新闻"
            }
            if (type.indexOf("2") !== -1) {
                result[2].title = "通知通告"
            }
            if (type.indexOf("3") !== -1) {
                result[2].title = "重要活动"
            }
            if (type.indexOf("4") !== -1) {
                result[2].title = "品牌活动"
            }
            if (type.indexOf("5") !== -1) {
                result[2].title = "专业服务"
            }
            if (type.indexOf("6") !== -1) {
                result[2].title = "公益在行动"
            }
        }

        if (type.indexOf("information") !== -1) {
            result.push({
                id: "Breadcrumb2",
                title: "资料",
                route: "/article?breadcrumb_type=" + type,

            })
            if (type === "information") {
                return result
            }
            result.push({
                id: "Breadcrumb3",
                title: "",
                route: "/article_next?breadcrumb_type=" + type,

            })
            if (type.indexOf("1") !== -1) {
                result[2].title = "研究报告"
            }
            if (type.indexOf("2") !== -1) {
                result[2].title = "社会责任报告"
            }
            if (type.indexOf("3") !== -1) {
                result[2].title = "政策法规"
            }
            if (type.indexOf("4") !== -1) {
                result[2].title = "政策解读"
            }
            if (type.indexOf("5") !== -1) {
                result[2].title = "抗疫惠企政策"
            }
            if (type.indexOf("6") !== -1) {
                result[2].title = "第五次会员代表大会"
            }
            if (type.indexOf("7") !== -1) {
                result[2].title = "历史资料"
            }
        }

        if (type.indexOf("about") !== -1) {
            result.push({
                id: "Breadcrumb2",
                title: "关于我们",
                route: "/article?breadcrumb_type=" + type,

            })
            if (type === "about") {
                return result
            }
            result.push({
                id: "Breadcrumb3",
                title: "",
                route: "/article_next?breadcrumb_type=" + type,

            })
            if (type.indexOf("1") !== -1) {
                result[2].title = "协会简介"
            }
            if (type.indexOf("2") !== -1) {
                result[2].title = "协会领导"
            }
            if (type.indexOf("3") !== -1) {
                result[2].title = "协会章程"
            }
            if (type.indexOf("4") !== -1) {
                result[2].title = "大事记"
            }
        }
        return result
    }
}